import React from "react";
import styled from "styled-components";

const Title = styled.h2`
  font-family: 'Geist Variable', 'Geist', sans-serif;
  font-weight: 600;
  font-size: clamp(22px, 3.5vw, 28px);
  color: oklch(.145 0 0);
  margin: 0 0 14px 0;
`;

const Paragraph = styled.p`
  color: #4b5563;
  font-size: 14px;
  margin: 8px 0 0 0;
`;

export default function PreSubmitInfo({ language = 'EN' }) {
  const copy = {
    EN: {
      title: 'Before you submit.',
      p1: 'Please review your actions one more time. Make sure each action has a clear title, a helpful description, and a realistic due date.',
      p2: 'Once submitted, your actions will be visible only to you and to HR leaders verified from your organization.',
    },
    FR: {
      title: 'Avant de soumettre',
      p1: 'Veuillez revoir vos actions une dernière fois. Assurez-vous que chaque action a un titre clair, une description utile et une date d’échéance réaliste.',
      p2: 'La soumission partagera votre plan avec votre organisation et l’enregistrera pour les suivis.',
    },
    ES: {
      title: 'Antes de enviar',
      p1: 'Revisa tus acciones una vez más. Asegúrate de que cada acción tenga un título claro, una descripción útil y una fecha límite realista.',
      p2: 'Al enviar, se compartirá tu plan con tu organización y se registrará para seguimientos.',
    },
  };
  const t = copy[language] || copy.EN;

  return (
    <div>
      <Title>{t.title}</Title>
      <Paragraph>{t.p2}</Paragraph>
    </div>
  );
}

